import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './InlineFieldLayout-hashed.scss';

const InlineFieldLayout = props => {
    const {
        labelContent, controlContent, messageContent, className, automationProperty
    } = props;
    return (
        <div className={cx(styles.inlineFieldLayout, className)} {...automationProperty}>
            {labelContent}
            <div className={styles.controls}>
                {controlContent}
                <div className={styles.messages}>{messageContent}</div>
            </div>
        </div>
    );
};

/**
 * @typedef {Object} InlineFieldLayout.propTypes
 * @property {string} [layoutContent] -
 * @property {string} [controlContent] -
 * @property {string} [messageContent] -
 * @property {string} [className] -
 */
InlineFieldLayout.propTypes = {
    /**
    * The content to output in the label portion of the layout
    **/
    labelContent: PropTypes.node,
    /**
    * The content to output in the control portion of the layout
    **/
    controlContent: PropTypes.node,
    /**
    * The content to output in the message portion of the layout
    **/
    messageContent: PropTypes.node,
    /**
    * CSS class name, additional style to apply to the layout
    **/
    className: PropTypes.string
};

InlineFieldLayout.displayName = 'InlineFieldLayout'; // displayName to appear React debug tools

InlineFieldLayout.labelClass = styles.label; // custom class to apply when rendering label content

/**
 * A component that provides layout for a field (label + control + message). Each 'field layout' component can accept React nodes
 * for each part of a field and is free to render as it likes.
 *
 * @param {Object} props - props for stateless functional component
 *
 * Properties: {@link InlineFieldLayout.propTypes}
 */
export default InlineFieldLayout;
